import { Select,Box, SelectChangeEvent, Grid, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Modal, Radio, TextField, InputAdornment, Autocomplete, MenuItem } from "@mui/material";
// import * as React from "react";
// import { Grid, SelectChangeEvent, Typography, Stack, Box } from "@mui/material";
import { RadioProps } from '@mui/material/Radio';
import  { FC, useState, useEffect } from "react";
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import HighlightOffTwoToneIcon from '@mui/icons-material/HighlightOffTwoTone';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { styled } from '@mui/material/styles';
import StarTwoToneIcon from '@mui/icons-material/StarTwoTone';
import { useAppDispatch, useAppSelector } from "../../store/hooks";

import CustomSelect, { IOptions } from "../FormFields/CustomSelect";
import { fetchBankById, fetchBanks } from '../../store/bankStore/bankThunk';
import qrImage from '../../assets/qr-image.png';
import { fetchGstOptions } from "../../store/gstStore/gstThunk";
import { makeStyles } from "@material-ui/core";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import moment from "moment";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

const useStyles = makeStyles({
    paper: {
      border: "1.5px solid #e9ecf1",
      width: '108%',
      boxShadow: 'none',
      marginLeft: '-6px',
      borderRadius: 7
    }
  });

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    transition: '0ms',
    width: 425,
    borderRadius: 2,
    bgcolor: 'background.paper',
    border: 'none',
    boxShadow: 24,
};

const BpIcon = styled('span')(({ theme }) => ({
    borderRadius: '50%',
    width: 16,
    height: 16,
    boxShadow:
      theme.palette.mode === 'dark'
        ? '0 0 0 1px rgb(16 22 26 / 40%)'
        : 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: theme.palette.mode === 'dark' ? '#394b59' : '#f5f8fa',
    backgroundImage:
      theme.palette.mode === 'dark'
        ? 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))'
        : 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2,
    },
    'input:hover ~ &': {
      backgroundColor: theme.palette.mode === 'dark' ? '#30404d' : '#ebf1f5',
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background:
        theme.palette.mode === 'dark' ? 'rgba(57,75,89,.5)' : 'rgba(206,217,224,.5)',
    },
}));
  
const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: '#137cbd',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
        display: 'block',
        width: 16,
        height: 16,
        backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
        content: '""',
    },
    'input:hover ~ &': {
        backgroundColor: '#106ba3',
    },
});
  
// Inspired by blueprintjs
function BpRadio(props: RadioProps) {
    return (
        <Radio
        disableRipple
        color="default"
        checkedIcon={<BpCheckedIcon />}
        icon={<BpIcon />}
        {...props}
        />
    );
}

interface PayToProps {
    visible: boolean;
    setVisible: (val:boolean) => void;
}
  

const PartyPrice: FC<PayToProps> = (props) => {

    const classes = useStyles();

    const [stockType, setStockType] = useState(1);
    const [stockAsOfDate, setStockAsOfDate] = useState<Date>(new Date());
    const onClose = () => {
        props.setVisible(false)
    }
    const handleDateChange = (newValue: Date | null, name: string | undefined) => {
        if (newValue) {
          setStockAsOfDate(newValue);
        }
      };
    return(
        <Modal
            open={props.visible}
            onClose={(event : any, reason:any) => {
                if (reason !== 'backdropClick') {
                    props.setVisible(true)
                }
            }}
        >
            <Box sx={style}>
            <Grid container >
                <Grid {...{ xs: 12, sm: 8, md: 4, lg: 12, p:2, pl:2, bgcolor:'#e9ecf1' }} style={{borderTopLeftRadius:8,borderTopRightRadius:8,height:50}} >
                <div style={{float:'right',marginTop:-7,marginRight:-5}}>
                    <IconButton size='small' >
                        <CheckCircleOutlineOutlinedIcon  color="primary"/>
                    </IconButton>
                    <IconButton size='small' onClick={onClose} style={{marginRight:-5}} >
                        <HighlightOffOutlinedIcon  color="error"/>
                    </IconButton>
                </div>
                <h3  style={{marginTop:-2}}>Add Party Price</h3>
                {/* {JSON.stringify(selectedBank)} */}
                </Grid>
                
            </Grid>
            
            <Grid container p={2} spacing={2}>
            <Grid item xs={12} >
            <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:14}}>Item Name</h5>
            <h5 style={{fontWeight:'normal',color:'#000',fontSize:15}}>{String('IT Fall Ceiling (1 mm Aluminium Bottom , 12 mm nova pan Shit)').length > 55 ? String('IT Fall Ceiling (1 mm Aluminium Bottom , 12 mm nova pan Shit)').substring(0,53) + '...' : String('IT Fall Ceiling (1 mm Aluminium Bottom , 12 mm nova pan Shit)')}</h5>
            </Grid>
            <Grid item xs={12} >
                <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:14}}>Select Party</h5>
                <Autocomplete
                    disablePortal
                    options={[]}
                    renderOption={(props, option: {label: string}) => (
                      <li {...props} 
                      style={{fontSize:14,height:40}}
                      >{option.label}</li>
                    )}
                    classes={{ paper: classes.paper }}
                    sx={{ width: '100%'}}
                    renderInput={(params) => <TextField {...params}
                      placeholder="Select Party"
                      className='c-text-field-4' 
                      sx={{width:'100%',mt:0.5,borderRadius:'8px!important'}} 
                      variant="standard" 
                      size='small'
                      InputProps={{...params.InputProps, disableUnderline: true}}
                    />}
                />
            </Grid>
            
            <Grid item xs={4} >
            <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:14}}>Item Sale Price</h5>
            <h5 style={{fontWeight:'normal',color:'#000',fontSize:15,marginBottom:10}}>₹ 200</h5>
            </Grid>

            <Grid item xs={8}>
                <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:14}}>Sale Price For Party</h5>
                <TextField 
                      placeholder="Enter Price"
                      required
                      size="small"
                      //{...methods.register("name")}
                      name='name'
                      className='c-text-field-4' 
                      variant="standard" 
                      sx={{width:'100%',mt:0.5,borderRadius:'8px!important'}} 
                      InputProps={{
                      disableUnderline: true,
                      startAdornment:<InputAdornment position="start" style={{marginTop:-5}}>₹</InputAdornment>
                      }}
                />
            </Grid>

            <Grid item xs={4} >
            <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:14}}>Item Discount</h5>
            <h5 style={{fontWeight:'normal',color:'#000',fontSize:15,marginBottom:10}}>10%</h5>
            </Grid>

            <Grid item xs={8}>
                <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:14}}>Discount For Party</h5>
                <TextField 
                      placeholder="Enter Discount"
                      required
                      size="small"
                      //{...methods.register("name")}
                      name='name'
                      className='c-text-field-4' 
                      variant="standard" 
                      sx={{width:'100%',mt:0.5,borderRadius:'8px!important'}} 
                      InputProps={{
                      disableUnderline: true,
                      endAdornment:<InputAdornment position="start" style={{marginTop:-5}}>%</InputAdornment>
                      }}
                />
            </Grid>

            <Grid item xs={4} >
            <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:14}}>Item Tax Rate(%)</h5>
            <h5 style={{fontWeight:'normal',color:'#000',fontSize:15,marginBottom:10}}>18%</h5>
            </Grid>

            <Grid item xs={8}>
                <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:14}}>Tax Rate(%) For Party</h5>
                <Autocomplete
                    disablePortal
                    options={[]}
                    renderOption={(props, option: {label: string}) => (
                      <li {...props} 
                      style={{fontSize:14,height:40}}
                      >{option.label}</li>
                    )}
                    classes={{ paper: classes.paper }}
                    sx={{ width: '100%'}}
                    renderInput={(params) => <TextField {...params}
                      placeholder="Select Tax Rate(%)"
                      className='c-text-field-4' 
                      sx={{width:'100%',mt:0.5,borderRadius:'8px!important'}} 
                      variant="standard" 
                      size='small'
                      InputProps={{...params.InputProps, disableUnderline: true}}
                    />}
                />
            </Grid>

            <Grid item xs={4} >
                <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:14}}>Set Limit</h5>
                <div style={{marginLeft:-5}}>
                  <BpRadio  checked={stockType === 1} onChange={()=> {
                    // handleListItemClick(1);
                    setStockType(1);
                  }} size="small" style={{marginRight:-3}}/>
                  <label onClick={()=> {
                    // handleListItemClick(1);
                    setStockType(1);
                  }}>Yes</label>
                  <BpRadio checked={stockType === 2} onChange={()=> {
                    // handleListItemClick(2);
                    setStockType(2);
                  }} size="small" style={{marginRight:-3,marginLeft:5}}/>
                  <label onClick={()=> {
                    // handleListItemClick(2);
                    setStockType(2);
                  }}>No</label>
                </div> 
            </Grid>

            <Grid item xs={8}>
                <h5 style={{fontWeight:'normal',color:'#9da7b7',fontSize:14}}>Valid Till Date</h5>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DesktopDatePicker
                    disabled={stockType === 2}
                    inputFormat="dd/MM/yyyy"
                    maxDate={moment().add(1).toDate()}
                    value={stockAsOfDate}
                    InputProps={{
                      disableUnderline: true,
                      style:{
                        fontSize:14,
                        height:28
                      },
                    }}
                    onChange={(value) => { handleDateChange(value, 'stockAsOfDate') }}
                    renderInput={(params) => 
                      <TextField {...params}
                        style={{width:'100%'}}
                        required 
                        variant="standard"
                        sx={{width:'100%',mt:0.5,borderRadius:'8px!important'}} 
                        className='c-text-field-4'
                        placeholder="Date Of Joining"
                        
                      />}
                  />
                </LocalizationProvider>
            </Grid>
                </Grid>
            </Box>
        </Modal>
    )
};
export default PartyPrice;